// InformeHtmlThumbnail.js — aperçu cliquable d'une pièce jointe HTML d'informe.
//
// Affiche la vignette `{informeId}_thumb.webp` générée au backend (screenshot du
// rendu), avec l'overlay au survol des images d'informe. Si la vignette manque
// (génération échouée, backfill pas encore passé), repli sur un bouton orange
// typé — même code couleur que les documents HTML.
//
// Pendant de `DocumentThumbnail` côté documents, adapté au fait qu'un informe
// n'a qu'un média et pas de mimetype stocké.

import React, { useState } from 'react';
import { Box, Button, alpha } from '@mui/material';
import CodeIcon from '@mui/icons-material/Code';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useTranslation } from 'react-i18next';
import { getInformeThumbUrl } from '../utils/informeMedia';

const HTML_COLOR = '#e67e22';

const InformeHtmlThumbnail = ({ informeId, onOpen, maxHeight = 300 }) => {
  const { t } = useTranslation();
  const [thumbFailed, setThumbFailed] = useState(false);

  if (thumbFailed) {
    return (
      <Button
        variant="outlined"
        startIcon={<CodeIcon />}
        endIcon={<OpenInNewIcon />}
        onClick={onOpen}
        sx={{
          borderColor: HTML_COLOR,
          color: HTML_COLOR,
          '&:hover': {
            borderColor: '#d35400',
            backgroundColor: alpha(HTML_COLOR, 0.05),
          },
        }}
      >
        {t('playerCardCreator.informeTab.viewHtml')}
      </Button>
    );
  }

  return (
    <Box
      onClick={onOpen}
      sx={{
        position: 'relative',
        display: 'inline-block',
        cursor: 'pointer',
        '&:hover .media-overlay': { opacity: 1 },
      }}
    >
      <Box
        component="img"
        src={getInformeThumbUrl(informeId)}
        alt="HTML"
        onError={() => setThumbFailed(true)}
        sx={{
          maxWidth: '100%',
          maxHeight,
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'grey.200',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          objectFit: 'cover',
          objectPosition: 'top center',
          display: 'block',
        }}
      />
      <Box
        className="media-overlay"
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.4)',
          borderRadius: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          opacity: 0,
          transition: 'opacity 0.2s',
        }}
      >
        <OpenInNewIcon sx={{ color: 'white', fontSize: 32 }} />
      </Box>
    </Box>
  );
};

export default InformeHtmlThumbnail;
